import React, { useEffect } from "react";
import EventDetailsTab from "../Compliance/details/EventDetailsTab";
import MainFilters from "../Compliance/filters/MainFilters";
import useComplianceView from "@hooks/useComplianceView";

const ComplianceView = () => {
  const { operator, companyId, onOrgTreeChange } = useComplianceView();

  useEffect(onOrgTreeChange, [operator, companyId]);

  return (
    <div className="flex-stretch gs-flex-container-vertical height-100">
      <MainFilters />
      <div className="mt-1 flex-stretch gs-flex-container-vertical height-100">
        <EventDetailsTab />
      </div>
    </div>
  );
};

export default ComplianceView;
